module.exports = __webpack_public_path__ + "static/media/IconTemplates_-19.74827c76.svg";